import React from 'react';
import ReactDom from 'react-dom';
import { handleDefaults } from '../helpers/utils';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import BookingFeeDisclaimerCombinedReducers from './booking-fee-disclaimer-combine-reducer';
import BookingFeeDisclaimerLink from './booking-fee-disclaimer-link';
import thunk from 'redux-thunk';

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

export default class HwrldBookingFeeDisclaimer {
  constructor(element, dynamicOptions) {
    const defaults = {
      hideTabs: false
    };
    this.element = element;
    this.options = handleDefaults(defaults, dynamicOptions);
    console.log('this.options 00', this.options);
    this.renderElm();
  }

	renderElm() {
    const store = createStoreWithMiddleware(
      BookingFeeDisclaimerCombinedReducers, window.devToolsExtension ? window.devToolsExtension() : f => f
    );

		ReactDom.render(
			<Provider store={store}>
				<BookingFeeDisclaimerLink options={this.options} />
			</Provider>
			,
			document.querySelector(this.element));
    }
}

window.HwrldBookingFeeDisclaimer = HwrldBookingFeeDisclaimer;
